import axios from 'axios';
import { useQuery } from 'react-query';
import { useState } from 'react';

const APP_VERSION = process.env.REACT_APP_VERSION;
const FETCH_VERSION_TIMEOUT = Number(
  process.env.REACT_APP_FETCH_MANIFEST_VERSION_TIMEOUT
);

const fetchManifest = () => {
  return axios
    .get(`/manifest.json?t=${Date.now()}`)
    .then(({ data: manifest, headers }) => {
      return {
        manifest,
        headers: {
          countryCode: headers.countrycode,
          countryNumber: headers.countrynumber,
        },
      };
    });
};

export function useManifest() {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const [config, setConfig] = useState({
    manifest: null,
    countryCode: '',
    countryNumber: 0,
  });

  const validateVersion = (data) => {
    const {
      manifest,
      headers: { countryCode, countryNumber },
    } = data;
    setConfig({ manifest, countryCode, countryNumber });

    if (manifest.version && APP_VERSION !== manifest.version) {
      setNewVersionAvailable(true);
    }
  };

  return {
    newVersionAvailable,
    config,
    request: useQuery('manifest', fetchManifest, {
      refetchInterval: FETCH_VERSION_TIMEOUT,
      onSuccess: validateVersion,
      // enabled: process.env.NODE_ENV === 'production',
    }),
  };
}
